import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const permissionsSlice = createSlice({
  name: "PermissionsReducer",
  initialState: { pageNo: 1, pageSize: 10, searchParam: null },
  reducers: {
    setPermissionPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPermissionPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setPermissionSearchParam: (state, action: PayloadAction<any>) => {
      state.searchParam = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setPermissionPageNo, setPermissionPageSize, setPermissionSearchParam } = permissionsSlice.actions;
// You must export the reducer as follows for it to be able to be read by the store.
export default permissionsSlice.reducer;